export const API = '/api'
export const CONTACT_URL = '/contact'
export const SUBSCRIPTION_URL = '/subscription'

export const CONTACT_US_BUTTON = 'button'
export const CONTACT_US_BUTTON_SCROLLED = 'scrolledButton'
